/**
 * Outlined "document with a pen" icon used to denote a saved-draft submission on
 * an order (e.g. the draft-saved state shown in the Auth Status column).
 *
 * @param props.width - SVG width (defaults to `16`).
 * @param props.height - SVG height (defaults to `16`).
 * @param props.stroke - Stroke color for the glyph (defaults to orange `#EF6C00`).
 * @returns The rendered file-pen SVG icon.
 */
const FilePenIcon = (props: {
  width?: string;
  height?: string;
  stroke?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "16"}
    height={props.height || "16"}
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_file_pen_icon)">
      <path
        d="M13.3307 4.66536V4.53203C13.3307 3.41193 13.3307 2.85187 13.1127 2.42405C12.921 2.04773 12.615 1.74176 12.2387 1.55002C11.8109 1.33203 11.2508 1.33203 10.1307 1.33203H5.86406C4.74396 1.33203 4.1839 1.33203 3.75608 1.55002C3.37976 1.74176 3.0738 2.04773 2.88205 2.42405C2.66406 2.85187 2.66406 3.41193 2.66406 4.53203V11.4654C2.66406 12.5855 2.66406 13.1455 2.88205 13.5733C3.0738 13.9497 3.37976 14.2556 3.75608 14.4474C4.1839 14.6654 4.74396 14.6654 5.86406 14.6654H8.33073M8.33073 7.33203H5.33073M7.66406 9.9987H5.33073M10.6641 4.66536H5.33073M11.9974 11.9987V8.33203C11.9974 7.77975 12.4451 7.33203 12.9974 7.33203C13.5497 7.33203 13.9974 7.77975 13.9974 8.33203V11.9987C13.9974 13.1033 13.102 13.9987 11.9974 13.9987C10.8928 13.9987 9.9974 13.1033 9.9974 11.9987V9.33203"
        stroke={props.stroke || "#EF6C00"}
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_file_pen_icon">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default FilePenIcon;
